import $ from 'jquery';

export const $html = $('html');
export const $body = $('body');
export const $htmlbody = $('html, body');
export const $window = $(window);



// WEBPACK FOOTER //
// ./4.plugins/Globals/Globals.js